import React, { useState } from 'react';

export const ImageZoom = ({ image }) => {
  const [isImageExpanded, setIsImageExpanded] = useState(false);
  function handleExpandImage() {
    setIsImageExpanded(true);
  }

  return (
    <div>
      <img
        onClick={handleExpandImage}
        src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${image}`}
        alt={`${image}-Imagem carregada`}
        className="entry-os-image"
        style={{ cursor: 'zoom-in' }}
      />

      {isImageExpanded && (
        <div
          onClick={() => setIsImageExpanded(false)}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100vw',
            height: '100vh',
            position: 'fixed',
            top: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 2000,
          }}
        >
          <img
            src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${image}`}
            alt="Expanded"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxHeight: '80%',
              maxWidth: '90%',
              cursor: 'zoom-out',
              zoom: 'initial',
            }}
          />
        </div>
      )}
    </div>
  );
};
